import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IncidentDetailComponent } from './incident-detail.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'incidents',
        children: [
          {
            path: '',
            component: IncidentDetailComponent,
          },
          {
            path: ':Id',
            component: IncidentDetailComponent,
          },
        ],
      },
    ]),
  ],
  exports: [RouterModule],
})
export class IncidentRoutingModule {}
